module.exports = __webpack_public_path__ + "static/media/r_itdot_13.e3973ce9.png";